



// // src/pages/Resources.js
// import React from "react";
// import { motion } from "framer-motion";

// function Resources() {
//   return (
//     <div className="container mt-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
//       {/* 🌈 Hero Section */}
//       <motion.section
//         className="text-center text-white"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 1 }}
//         style={{
//           background: "linear-gradient(to right, #6a11cb, #2575fc)",
//           padding: "50px 20px",
//           borderRadius: "15px",
//           boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <motion.h1
//           className="display-4"
//           style={{
//             fontWeight: "700",
//             fontSize: "3rem",
//             textShadow: "2px 2px 10px rgba(0, 0, 0, 0.5)",
//           }}
//           initial={{ opacity: 0, scale: 0.8 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 1, delay: 0.3 }}
//         >
//           Resources for Spiritual Healing and Jain Wisdom
//         </motion.h1>

//         <motion.p
//           className="lead"
//           style={{
//             fontSize: "1.25rem",
//             marginTop: "20px",
//             opacity: 0.85,
//             maxWidth: "800px",
//             margin: "0 auto",
//           }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 1, delay: 0.6 }}
//         >
//           Explore articles, videos, books, and other resources to deepen your spiritual journey.
//         </motion.p>

//         <motion.hr
//           className="my-4"
//           initial={{ scaleX: 0 }}
//           animate={{ scaleX: 1 }}
//           transition={{ duration: 1, delay: 0.8 }}
//           style={{ border: "2px solid white", width: "60%", margin: "20px auto" }}
//         />

//         <motion.p
//           style={{
//             fontSize: "1.2rem",
//             maxWidth: "700px",
//             margin: "0 auto",
//           }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 1, delay: 1 }}
//         >
//           Discover more about Bhaktamar, Jainism, and the teachings of Dr. Pranamsagar Ji Maharaj.
//         </motion.p>
//       </motion.section>

//       {/* 📚 Articles Section */}
//       <motion.section
//         className="mt-5 p-4"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ duration: 0.8 }}
//         style={{
//           backgroundColor: "#f0f0f0",
//           borderRadius: "12px",
//           boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <h2
//           className="text-center mb-4"
//           style={{ color: "#333", fontWeight: "700", fontSize: "2.5rem" }}
//         >
//           Articles on the Bhaktamar Stotra
//         </h2>
//         <div className="row justify-content-center">
//           {[
//             {
//               title: "Wikipedia: Detailed information on Bhaktamar Stotra",
//               desc: "Learn about the origins, history, and significance of Bhaktamar.",
//               link: "https://en.wikipedia.org/wiki/Bhaktāmara_Stotra",
//             },
//             {
//               title: "Jainpedia: Thematic summary of the Stotra's significance",
//               desc: "An in-depth summary of the stotra and its spiritual importance.",
//               link: "https://jainpedia.org/themes/principles/sacred-writings/highlights-of-jainpedia/bhaktamara-stotra/",
//             },
//           ].map((article, i) => (
//             <motion.div
//               key={i}
//               className="col-lg-4 col-md-6 col-sm-12 mb-4"
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6, delay: i * 0.2 }}
//             >
//               <motion.div
//                 whileHover={{ scale: 1.05, boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}
//                 style={{
//                   backgroundColor: "#fff",
//                   borderRadius: "10px",
//                   padding: "20px",
//                   boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
//                   textAlign: "center",
//                   height: "100%",
//                 }}
//               >
//                 <h4 style={{ color: "#2575fc", fontWeight: "600" }}>{article.title}</h4>
//                 <p style={{ fontSize: "1rem", color: "#444" }}>{article.desc}</p>
//                 <a
//                   href={article.link}
//                   className="btn btn-primary"
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     marginTop: "10px",
//                     backgroundColor: "#2575fc",
//                     border: "none",
//                     borderRadius: "25px",
//                     padding: "10px 25px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Read Article
//                 </a>
//               </motion.div>
//             </motion.div>
//           ))}
//         </div>
//       </motion.section>

//       {/* 🎥 YouTube Videos Section */}
//       <motion.section
//         className="mt-5 p-4"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ duration: 0.8 }}
//         style={{
//           backgroundColor: "#f0f0f0",
//           borderRadius: "12px",
//           boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <h2
//           className="text-center mb-4"
//           style={{ color: "#333", fontWeight: "700", fontSize: "2.5rem" }}
//         >
//           YouTube Videos on the Bhaktamar Stotra
//         </h2>
//         <div className="row justify-content-center">
//           {[
//             {
//               src: "https://www.youtube.com/embed/Y2DowbzgjCc",
//               title: "Bhaktamar Stotra by Dr. Pranamsagarji Maharaj",
//             },
//             { src: "https://www.youtube.com/embed/u3BU9utMv-0", title: "Bhaktamar Stotra" },
//             {
//               src: "https://www.youtube.com/embed/JVKztqh8WD0",
//               title: "Importance of Bhaktamar Path by Muni Pramansagar Ji",
//             },
//           ].map((video, i) => (
//             <motion.div
//               key={i}
//               className="col-lg-4 col-md-6 col-sm-12 mb-4"
//               initial={{ opacity: 0, scale: 0.9 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6, delay: i * 0.2 }}
//             >
//               <motion.div
//                 whileHover={{ scale: 1.05, boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}
//                 style={{
//                   backgroundColor: "#fff",
//                   borderRadius: "10px",
//                   padding: "15px",
//                   boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
//                   textAlign: "center",
//                   height: "100%",
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "relative",
//                     paddingBottom: "56.25%", // 16:9 aspect ratio
//                     height: 0,
//                     overflow: "hidden",
//                     borderRadius: "12px",
//                   }}
//                 >
//                   <iframe
//                     src={video.src}
//                     title={video.title}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       height: "100%",
//                       borderRadius: "12px",
//                     }}
//                   ></iframe>
//                 </div>
//                 <h5
//                   className="mt-3"
//                   style={{ fontWeight: "600", color: "#2575fc", fontSize: "1.1rem" }}
//                 >
//                   {video.title}
//                 </h5>
//               </motion.div>
//             </motion.div>
//           ))}
//         </div>
//       </motion.section>

//       {/* 📱 Responsive Adjustments */}
//       <style>
//         {`
//           @media (max-width: 992px) {
//             h1 { font-size: 2rem !important; }
//             h2 { font-size: 2rem !important; }
//             p { font-size: 1rem !important; }
//             iframe { height: 250px !important; }
//           }

//           @media (max-width: 576px) {
//             h1 { font-size: 1.7rem !important; }
//             h2 { font-size: 1.5rem !important; }
//             p { font-size: 0.95rem !important; line-height: 1.5; }
//             iframe { height: 200px !important; }
//             .btn { width: 100%; border-radius: 8px !important; }
//           }
//         `}
//       </style>
//     </div>
//   );
// }

// export default Resources;


import React from "react";
import { motion } from "framer-motion";

function Resources() {
  return (
    <div
      className="container mt-5"
      style={{ fontFamily: "'Poppins', sans-serif", color: "#4b2e05" }}
    >
      {/* 🌅 Hero Section */}
      <motion.section
        className="text-center"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{
          background: "linear-gradient(120deg, #ffe7ba, #ffd6b5, #ffccb5)", // soft sunrise tones
          padding: "60px 20px",
          borderRadius: "20px",
          boxShadow: "0 4px 20px rgba(255, 200, 120, 0.4)",
          color: "#4b2e05",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* Decorative Soft Glow */}
        <div
          style={{
            position: "absolute",
            top: "-80px",
            right: "-100px",
            width: "250px",
            height: "250px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.5), transparent)",
            borderRadius: "50%",
            zIndex: 0,
          }}
        ></div>

        <motion.h1
          className="display-4"
          style={{
            fontWeight: "800",
            fontSize: "2.8rem",
            zIndex: 1,
            position: "relative",
            textShadow: "0 3px 12px rgba(255, 230, 170, 0.6)",
          }}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
        >
          Resources for Spiritual Healing & Jain Wisdom
        </motion.h1>

        <motion.p
          className="lead"
          style={{
            fontSize: "1.2rem",
            marginTop: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            lineHeight: "1.8",
            color: "#5a3a0e",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Explore enlightening books, videos, and articles that deepen your
          understanding of Bhaktamar Stotra and Jain philosophy.
        </motion.p>

        <motion.hr
          className="my-4"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          style={{
            border: "2px solid #b66b00",
            width: "60%",
            margin: "25px auto",
            opacity: 0.6,
          }}
        />
      </motion.section>

      {/* 📚 Articles Section */}
      <motion.section
        className="mt-5 p-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{
          background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          className="text-center mb-4"
          style={{
            color: "#b66b00",
            fontWeight: "700",
            fontSize: "2.5rem",
            textShadow: "0 2px 10px rgba(255, 200, 150, 0.4)",
          }}
        >
          Articles on the Bhaktamar Stotra
        </h2>
        <div className="row justify-content-center">
          {[
            {
              title: "Wikipedia: Detailed Information on Bhaktamar Stotra",
              desc: "Learn about the origins, history, and significance of the Bhaktamar Stotra.",
              link: "https://en.wikipedia.org/wiki/Bhaktāmara_Stotra",
            },
            {
              title: "Jainpedia: Thematic Summary of the Stotra's Significance",
              desc: "An insightful analysis of the Bhaktamar and its spiritual importance in Jainism.",
              link: "https://jainpedia.org/themes/principles/sacred-writings/highlights-of-jainpedia/bhaktamara-stotra/",
            },
          ].map((article, i) => (
            <motion.div
              key={i}
              className="col-lg-4 col-md-6 col-sm-12 mb-4"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
            >
              <motion.div
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 10px 25px rgba(249, 180, 100, 0.3)",
                }}
                style={{
                  backgroundColor: "#fffaf3",
                  borderRadius: "15px",
                  padding: "25px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  textAlign: "center",
                  height: "100%",
                  border: "1px solid rgba(255,200,150,0.3)",
                  transition: "all 0.4s ease",
                }}
              >
                <h4 style={{ color: "#b66b00", fontWeight: "600" }}>
                  {article.title}
                </h4>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#6b4a2e",
                    lineHeight: "1.7",
                    marginBottom: "20px",
                  }}
                >
                  {article.desc}
                </p>
                <a
                  href={article.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    background: "linear-gradient(145deg, #c97b2b, #ffb347)",
                    color: "#fff",
                    padding: "10px 25px",
                    borderRadius: "50px",
                    fontWeight: "600",
                    textDecoration: "none",
                    boxShadow: "0 4px 12px rgba(255,150,50,0.4)",
                    transition: "all 0.3s ease",
                    display: "inline-block",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(255,180,80,0.6)";
                    e.currentTarget.style.transform = "translateY(-3px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(255,150,50,0.4)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  Read Article
                </a>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* 🎥 YouTube Videos Section */}
      <motion.section
        className="mt-5 p-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{
          background: "linear-gradient(to bottom, #fffaf3, #fff3e1)",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          className="text-center mb-4"
          style={{
            color: "#b66b00",
            fontWeight: "700",
            fontSize: "2.5rem",
            textShadow: "0 2px 10px rgba(255, 200, 150, 0.4)",
          }}
        >
          Videos on the Bhaktamar Stotra
        </h2>
        <div className="row justify-content-center">
          {[
            {
              src: "https://www.youtube.com/embed/Y2DowbzgjCc",
              title: "Bhaktamar Stotra by Dr. Pranamsagarji Maharaj",
            },
            {
              src: "https://www.youtube.com/embed/u3BU9utMv-0",
              title: "Complete Bhaktamar Stotra Path",
            },
            {
              src: "https://www.youtube.com/embed/JVKztqh8WD0",
              title: "The Importance of Bhaktamar Path",
            },
          ].map((video, i) => (
            <motion.div
              key={i}
              className="col-lg-4 col-md-6 col-sm-12 mb-4"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
            >
              <motion.div
                whileHover={{
                  scale: 1.03,
                  boxShadow: "0 10px 30px rgba(255, 200, 150, 0.3)",
                }}
                style={{
                  backgroundColor: "#fffaf3",
                  borderRadius: "15px",
                  padding: "15px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  textAlign: "center",
                  height: "100%",
                  border: "1px solid rgba(255,200,150,0.3)",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                    overflow: "hidden",
                    borderRadius: "12px",
                  }}
                >
                  <iframe
                    src={video.src}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "12px",
                    }}
                  ></iframe>
                </div>
                <h5
                  className="mt-3"
                  style={{
                    fontWeight: "600",
                    color: "#b66b00",
                    fontSize: "1.1rem",
                  }}
                >
                  {video.title}
                </h5>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* 📱 Responsive Styles */}
      <style>
        {`
          @media (max-width: 992px) {
            h1 { font-size: 2rem !important; }
            h2 { font-size: 2rem !important; }
            p { font-size: 1rem !important; }
            iframe { height: 250px !important; }
          }

          @media (max-width: 576px) {
            h1 { font-size: 1.6rem !important; }
            h2 { font-size: 1.4rem !important; }
            p { font-size: 0.95rem !important; line-height: 1.5; }
            iframe { height: 200px !important; }
            .btn { width: 100%; border-radius: 10px !important; }
          }
        `}
      </style>
    </div>
  );
}

export default Resources;
